export default __webpack_public_path__ + "locales/sr-Latn-RS/EmptyView.json?hash=12da6dbc1d1e098487be100bc7a17602";